export default __webpack_public_path__ + "static/media/modelLynnMinting.577b0209.png";